/**
 * Public route wrapper: /split/:code
 *
 * No auth required. Renders the bill-split guest experience. This page
 * intentionally lives outside the AuthedShell because guests don't need
 * a TipLingo account — the share code IS the secret.
 */

import React from "react";
import { Toaster } from "sonner";
import BillSplitGuestView from "../components/split/BillSplitGuestView";

export default function SplitGuestPage() {
  return (
    <>
      <BillSplitGuestView />
      <Toaster position="top-center" richColors />
    </>
  );
}
